import { useEffect } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { ArtistGroups } from "./ArtistGroups";
import ArtistManagement from "./ArtistManagement";
import CampaignForm from "./CampaignForm";
import { Login } from "./Login";
import Messages from "./Messages";
import { StripeConnectRedirect } from "./StripeConnectRedirect";
import { useUserContext } from "./UserContextProvider";

export const ROUTES = {
  LOGIN: "/login",
  STRIPE_CONNECT: "/stripe-connect/:artistGroupId/:redirectTo",
  ACCOUNT_LOGIN: "/account-login",
  LOGIN_DEV: "/login-max-dev",
  MESSAGES: "/messages/:artistGroupId",
  SHOUTOUT_MESSAGES: "/messages/:artistGroupId/:shoutoutId",
  NEW_CAMPAIGN_FORM: "/new-campaign/:artistGroupId",
  EDIT_CAMPAIGN_FORM: "/edit-campaign/:artistGroupId/:shoutoutId",
  ARTIST_MANAGEMENT: "/artist-management",
  USER: "/user",
  ARTISTS_GROUPS: "/artists",
};

const ScrollToTop = ({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);

  return null;
};

const RouterScrollToTop = withRouter(ScrollToTop);

const ProtectedRoute = ({ path, children, exact = false }) => {
  const { isLoggedIn } = useUserContext();
  return (
    <>
      {isLoggedIn ? (
        <Route exact={exact} path={path}>
          {children}
        </Route>
      ) : (
        <Redirect to={ROUTES.LOGIN} />
      )}
    </>
  );
};

const Routes = () => {
  const { isLoggedIn } = useUserContext();

  const DefaultRoute = () => (
    <Redirect to={isLoggedIn ? ROUTES.ARTISTS_GROUPS : ROUTES.LOGIN} />
  );

  return (
    <>
      <RouterScrollToTop />
      <Switch>
        <ProtectedRoute exact path={ROUTES.STRIPE_CONNECT}>
          <StripeConnectRedirect />
        </ProtectedRoute>
        <ProtectedRoute exact path={ROUTES.MESSAGES}>
          <Messages />
        </ProtectedRoute>
        <ProtectedRoute exact path={ROUTES.SHOUTOUT_MESSAGES}>
          <Messages />
        </ProtectedRoute>
        <ProtectedRoute path={ROUTES.NEW_CAMPAIGN_FORM}>
          <CampaignForm />
        </ProtectedRoute>
        <ProtectedRoute path={ROUTES.EDIT_CAMPAIGN_FORM}>
          <CampaignForm />
        </ProtectedRoute>
        <ProtectedRoute path={ROUTES.ARTIST_MANAGEMENT}>
          <ArtistManagement />
        </ProtectedRoute>
        <ProtectedRoute exact path={ROUTES.ARTISTS_GROUPS}>
          <ArtistGroups />
        </ProtectedRoute>
        <Route path={ROUTES.LOGIN}>
          <Login />
        </Route>
        <Route component={() => <DefaultRoute />} />
      </Switch>
    </>
  );
};
export default Routes;
